// 통화 금액 표기
//
// 결제는 사용자 지역 통화로 청구되어 KRW·USD 말고도 JPY·CNY·HKD·PLN·VND 가 실제로 들어옵니다.
// 종전처럼 `code === 'KRW' ? '₩' : '$'` 로 나누면 두 가지가 동시에 틀립니다.
//   - 기호: CNY·HKD·PLN 이 전부 미국 달러($)처럼 보입니다
//   - 자릿수: JPY·VND 는 소수 단위가 없는데 `.00` 이 붙습니다
// Intl 이 통화 코드만으로 기호와 자릿수를 모두 정하므로 그 결과를 그대로 씁니다.
//
// currencyDisplay 는 기본값을 씁니다. 'narrowSymbol' 은 USD·HKD 가 똑같이 '$',
// JPY·CNY 가 똑같이 '¥' 가 되어, 구분하려는 목적과 정반대가 됩니다.
//   KRW → ₩24,130 / USD → US$24,130.00 / JPY → JP¥24,130 / HKD → HK$24,130.00

/**
 * @param {number|string|null} amount 금액
 * @param {string} currencyCode ISO 4217 통화 코드 (KRW, USD, JPY …)
 * @returns {string}
 */
export const formatMoney = (amount, currencyCode) => {
  const value = Number(amount) || 0
  const code = typeof currencyCode === 'string' ? currencyCode.trim().toUpperCase() : ''

  try {
    return new Intl.NumberFormat('ko-KR', { style: 'currency', currency: code }).format(value)
  } catch (e) {
    // 화폐 테이블에 없는 코드나 빈 값이 섞여 들어오면 Intl 이 RangeError 를 던집니다.
    // 금액을 통째로 잃는 것보다 코드를 앞에 붙여서라도 보여 주는 편이 낫습니다.
    return `${code || '?'} ${value.toLocaleString('ko-KR')}`
  }
}
